export default "__VITE_ASSET__gkWOrawq__"